import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pluralDays'
})
export class PluralDaysPipe implements PipeTransform
{
  public transform(key: string, number: number): string
  {
    return `${key}.${number == 0 ? 'none' : number == 1 ? 'SINGULAR' : 'PLURIAL'}`;
  }
}
